import { Link } from '@tanstack/react-router';
import { User, Lock, Settings, LogOut, ChevronRight } from 'lucide-react';

import { useLogout } from '@/lib/hooks/useLogout';

// NOTE: `/settings`'s Profile/Security section switch (see SettingsLayout.tsx)
// is driven by local component state (`useState<Section>`), not a URL search
// param — there is no `validateSearch`/deep-linking support today. All three
// rows below therefore link to the same `/settings` route with no `search`
// prop; Preferences pointing at the same place as Edit Profile is the agreed
// placeholder behavior until Preferences has its own screen.
const LINK_ROWS = [
  { key: 'profile', icon: User, label: 'Edit Profile', description: 'Update your personal information' },
  { key: 'security', icon: Lock, label: 'Change Password', description: 'Update your account password' },
  { key: 'preferences', icon: Settings, label: 'Preferences', description: 'Manage your notification and email preferences' },
];

export function AccountSettingsCard() {
  const logout = useLogout();

  return (
    <section className="rounded-xl border border-[#e8e4df] bg-white p-6" aria-label="Account settings">
      <h2 className="font-heading text-base font-bold text-[#1a1714]">Account Settings</h2>
      <div className="mt-4 divide-y divide-[#f2f0ed]">
        {LINK_ROWS.map(({ key, icon: Icon, label, description }) => (
          <Link
            key={key}
            to="/settings"
            className="flex items-center gap-3 py-3 transition-colors hover:bg-[#faf9f7]"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f2f0ed]">
              <Icon className="h-4 w-4 text-[#6b6459]" />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-[#1a1714]">{label}</p>
              <p className="text-xs text-[#9a9589]">{description}</p>
            </div>
            <ChevronRight className="h-4 w-4 text-[#c4c0b8]" />
          </Link>
        ))}
        <button
          type="button"
          onClick={() => void logout()}
          className="flex w-full items-center gap-3 py-3 text-left transition-colors hover:bg-[#faf9f7]"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f2f0ed]">
            <LogOut className="h-4 w-4 text-[#6b6459]" />
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-[#1a1714]">Logout</p>
            <p className="text-xs text-[#9a9589]">Sign out of your account</p>
          </div>
          <ChevronRight className="h-4 w-4 text-[#c4c0b8]" />
        </button>
      </div>
    </section>
  );
}
